import React, {useEffect, useRef, useState} from 'react';
import ExcelExport from "@progress/kendo-react-excel-export/dist/npm/ExcelExport";
import ExcelExportColumn from "@progress/kendo-react-excel-export/dist/es/ExcelExportColumn";
import Button from "@material-ui/core/Button";
import {ExcelIcon} from "../../UIComponents/icons";
import {green} from "@material-ui/core/colors";
import moment from "moment";
import {getImageDimensions} from "../../Helpers/b64toBiteArray";
import {process} from "@progress/kendo-data-query";
import _ from "lodash";
const decimalFormat= ['0','0.0','0.00','0.000','0.0000']
const IncomeTaxExcelExport = ({data,group,fileName,payrollDate,company,logoLeft,logoRight,decimalPlace=2,footerItems,showFooter,columns}) => {

    const [result,setResultF] = useState(process(data.slice(0), {group}))
    const setResult  = result => {
        const r = _.cloneDeep(result)
        // console.log({r})
        if(r.data && r.data[0] && r.data[0].field) {
            r.data.forEach(d=>{
                // console.log({d})
                d.items && d.items.forEach((i,index)=>{
                    i.sn=index+1
                })
            })
        }
        setResultF(r)
    }
    useEffect(() => {
        //     if (data !== data) {

        setResult(process(data.slice(0), {group}))


        //  }
    }, [data]);

    const getSum = ({column}) => {
        // console.log(field)
        return data.reduce((sum,cv)=>sum+(+cv[column.field].toFixed(2)),0).toFixed(2)
    }
    const fetchImage = (url) => {
        return fetch(url)
            .then(res => res.arrayBuffer())
            .then(data => getImageDimensions(url).then(dim=>({data,dim,type: "image/png"})))
    }
    const loadLogosAndExportToExcel = () => {

        // const payDayLogo = 'data:image/png;base64,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'
        // const url = logoLeft; //"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="
        if(logoLeft&&logoRight) {
          Promise.all([fetchImage(logoLeft),fetchImage(logoRight)]).then(d=>{

              exportToExcel({logoLeft: d[0],logoRight: d[1]},result,company,payrollDate,data)
          })
        }
        else {
            exportToExcel(null,result,company,payrollDate,data);
        }
    }


    const ref = useRef();
    const exportToExcel = (images,data, company,payrollDate,allData) => {


        const options = ref.current.workbookOptions();
        const sheet = options.sheets[0];
        if(images){
            options.images = images;
            sheet.drawings = [
                {
                    topLeftCell: "A1",
                    offsetX: 12,
                    offsetY: 3,
                    width: (images["logoLeft"].dim.w/images["logoLeft"].dim.h)*80,
                    height: 80,
                    image: "logoLeft"
                },
                {
                    topLeftCell: "N1",
                    offsetX: 0,
                    offsetY: 3,
                    width: (images["logoRight"].dim.w/images["logoRight"].dim.h)*80,
                    height: 80,
                    image: "logoRight"
                },
            ]
        }
        // sheet.frozenRows = 3;
       // sheet.mergedCells = ["A1:F1","A2:F2"];
       //  const cols = columns.filter(c=>c.show).length;
        // sheet.mergedCells = [`A1:${String.fromCharCode(64 + cols-1)}1`,`A2:${String.fromCharCode(64 + cols-1)}2`];

        const fStart = 7 + sheet.rows.length + 1 // row number where footer should start
        // console.log( `{A${fStart}:D${fStart}`, `{E${fStart}:I${fStart}`, `{J${fStart}:M${fStart}`)
        sheet.mergedCells = [
            "A1:B1",
            "C1:F1","G1:N1",
            "A2:N2",
            "A3:C4","D3:F4","G3:I4","J3:K3","L3:N4",
            "A5:B5","C5:E5","F5:J5","K5:N6",
            "A6:B6","C6:D6","E6:F6","G6:H6","I6:J6",
            "A7:N7",
            `A${fStart}:D${fStart}`, `E${fStart}:J${fStart}`, `K${fStart}:N${fStart}`,
            `B${fStart+1}:C${fStart+1}`, `F${fStart+1}:G${fStart+1}`, `H${fStart+1}:J${fStart+1}`,`K${fStart+1}:L${fStart+1}`,`M${fStart+1}:N${fStart+1}`,
            `B${fStart+2}:C${fStart+2}`, `F${fStart+2}:G${fStart+2}`, `H${fStart+2}:J${fStart+2}`,`K${fStart+2}:L${fStart+2}`,`M${fStart+2}:N${fStart+2}`,
       `B${fStart+3}:C${fStart+3}`, `F${fStart+3}:G${fStart+3}`, `H${fStart+3}:J${fStart+3}`,`K${fStart+3}:L${fStart+3}`,`M${fStart+3}:N${fStart+3}`,
                `B${fStart+4}:C${fStart+4}`, `F${fStart+4}:G${fStart+4}`, `H${fStart+4}:J${fStart+4}`,`K${fStart+4}:L${fStart+4}`,`M${fStart+4}:N${fStart+4}`,
            `A${fStart+5}:N${fStart+5}`,
            `A${fStart+6}:D${fStart+7}`, `E${fStart+6}:I${fStart+6}`, `J${fStart+6}:K${fStart+6}`,`L${fStart+6}:N${fStart+6}`,
            `E${fStart+7}:I${fStart+7}`, `J${fStart+7}:K${fStart+7}`, `L${fStart+7}:N${fStart+7}`,

        ];
        sheet.name = "IncomeTax Declaration";

        const headerRow = [
            {
            value:'',
            fontSize: 20,
            textAlign: "center",

        },

            {
            value:'ኢትዮጲያ ፌደራላዊ ዲሞከራሲያዊ ሪፐብሊክ\n የኢትዮጲያ ገቢዎችና ጉሙሩክ ባለስልጣን\n',
            verticalAlign:"middle",
            fontSize: 15,
            textAlign: "center",
            background:"#2b3c3c",
                wrap: true,
            color:"#ffffff",
            bold:true
        },
            {
                value:'ሠንጠረዥ "ሀ" የስራ ግብር ክፍያ ማስታወቂያ ቅጽ (ለተቀጣሪዎች)\n (የገቢ ግብር አዋጅ ቁጥር 976/2016 ና ገቢ ግብር ደንብ ቁጥር 410/2009)',
                verticalAlign:"middle",
                fontSize: 15,
                textAlign: "center",
                wrap: true,
                bold:true
            }

        ];
        const sectionOneTitle = [
            {
                value:'ክፍል 1 የግብር ከፋይ ዝርዝር መረጃ',
                textAlign: "center",

            },
        ]

        const sectionOne = [
            {
                value:`1. የግብር ከፋይ ስም: ${company.name||''}`,


            },
            {
                value:`3. የግብር ከፋይ መለያ ቁጥር: ${company.tinNo?company.tinNo||'':''}`,


            },
            {
                value:'4. የግብር ከፋይ ሂሳብ ቁጥር',



            },
            {
                value:'5. የክፍያ ጊዜ',


            },
            {
                value:'Page 1 of ___',
                verticalAlign: "top",



            },
        ]

        const sectionOne2 = [


            {
                    value:`ወር: ${moment(payrollDate).format('MMMM')}`,



            },
            {
                value:`ዓ.ም. ${moment(payrollDate).format('YYYY')}`,



            }

        ]

        const sectionOne3 = [


            {
                value:`2a. ከልል ${company.address ? company.address.city||'':''}`,



            },
            {
                value:`2b. ዞን/ክፍለ ከተማ  ${company.address ? company.address.subcity||'' : ''}`,



            },
            {
                value:'5. የግብር ሰብሳቢ መ/ቤት ስም',



            },
            {
                value:'የሰነድ ቁጥር (ለቢሮ አገልግሎት ብቻ)',
                verticalAlign:"top",



            }
        ]
        const sectionOne4 = [


            {
                value:`2c ወረዳ ${company.address ? company.address.woreda||'' : ''}`,



            },
            {
                value:`2d ቀበሌ/ገበሬ ማህበር  ${company.address ? company.address.kebele||'': ''}`,



            },
            {
                value:`2e. የቤት ቁጥር  ${company.address ? company.address.houseNumber||'' : ''}`,



            },
            {
                value:`6. የስልክ ቁጥር  ${company.address ? company.address.phoneNumber||'' : ''}`,



            },
            {
                value:`7. ፋክስ ቁጥር  ${company.address ? company.address.fax||'' : ''}`



            },
        ]

        const sectionTwoTitle = [
            {
                value:'ሠንጠረዥ 2. ማስታወቂያ ዝርዝር መረጃ',
                textAlign: "center",

            },
        ]

        const sectionFooterTitle = [
            {
                value:'ክፍል 3. የወሩ የተጠቃለለ ሂሳብ',
                textAlign: "center",

            },
            {
                value:'ክፍል 4- በዚህ ወር ስራ የለቀቁ ሠራተኞች ዝርዝር መረጃ',
                textAlign: "center",

            },
            {
                value:'ለቢሮ አገልግሎት ብቻ',
                textAlign: "center",

            }
        ]
        const sectionFooter1 = [
            {
                value:'10',
                textAlign: "right",
                wrap:true,


            },
            {
                value:'በዚህ ወር ደምውዝ ሚከፈላቸው ሰራተኞች ብዛት',
                textAlign: "left",
                wrap:true,

            },
            {
                value:allData.length,
                textAlign: "left",
                wrap:true,

            },
            {
                value:'ተ.ቁ.',
                textAlign: "left",
                wrap:true,

            },
            {
                value:'የሠራተኛው የግብር ከፋይ ቁጥር',
                textAlign: "left",
                wrap:true,

            },

            {
                value:'የሠራተኛው ስም /የአባት ሰምና የአያት ስም',
                textAlign: "left",
                wrap:true,

            },
            {
                value:'የተከፈለብት ቀን',
                textAlign: "left",
                wrap:true,

            },
            {
                value:'',
                textAlign: "left",

            },

        ]
        const sectionFooter2 = [
            {
                value:'20',
                textAlign: "right",
                wrap:true,

            },
            {
                value:'የውሩ ጠቅላላ የስራ ገብር የሚከፈልበት ገቢ (ከላይ ካለው ሠንጠረዥ (በ))',
                textAlign: "left",
                wrap:true,

            },
            {
                value:+allData.reduce((sum, cv) => sum + (+cv.taxableIncome.toFixed(2)), 0).toFixed(2),
                textAlign: "left",
                wrap:true,

            },
            {
                value:'',
                textAlign: "left",
                wrap:true,

            },
            {
                value:'',
                textAlign: "left",
                wrap:true,

            },
            {
                value:'',
                textAlign: "left",

            },
            {
                value:'የደረሰኝ ቁጥር',
                textAlign: "left",
                wrap:true,

            },
            {
                value:'',
                textAlign: "left",

            },


        ]
        const sectionFooter3 = [
            {
                value:'30',
                textAlign: "right",

            },
            {
                value:'የወሩ ጠቅላላ መከፈል ያለበት የሥራ ገበር (ከላይ ካለው ሠንጠረዥ (ተ) )',
                textAlign: "left",
                wrap:true,

            },
            {
                value:+allData.reduce((sum, cv) => sum + (+cv.incomeTax.toFixed(2)), 0).toFixed(2),
                textAlign: "left",

            },
            {
                value:'',
                textAlign: "left",

            },
            {
                value:'',
                textAlign: "left",

            },
            {
                value:'',
                textAlign: "left",

            },
            {
                value:'የገንዘብ ልክ',
                textAlign: "left",

            },
            {
                value:'',
                textAlign: "left",

            },

        ]
        const sectionFooter4 = [
            {
                value:'',
                textAlign: "left",

            },
            {
                value:'',
                textAlign: "left",

            },
            {
                value:'',
                textAlign: "left",

            },
            {
                value:'',
                textAlign: "left",

            },
            {
                value:'',
                textAlign: "left",

            },
            {
                value:'',
                textAlign: "left",

            },
            {
                value:'የቼክ ቁጥር',
                textAlign: "left",

            },
            {
                value:'',
                textAlign: "left",

            }


        ]

        const sectionFooterLastTitle = [
            {
                value:'ክፍል 5 የትክክለኛነት ማረጋገጫ',
                textAlign: "center",

            },


        ]

        const sectionFooterLast1 = [
            {
                value:'ከላይ የተገለጸው ማስታወቂያና የተሰጠው መረጃ ሙሉ በሙሉ የተሟላና ትክክለኛ መሆኑን አረጋገጣለሁ። ትክክለኛ ያልሆነ መረጃ ማቅረብ በግብር ሀጎችም ሆ በወንጀለኛ ሕግ የሚያስቀጣ መሆኑን እገነዘባለሁ',
                wrap: true,
                verticalAlign:"top",

            },
            {
                value:'የግብር ከፋይ ሀጋዊ ወኪሉ',



            },
            {
                value:'ማሕተም',
                verticalAlign:"top",
                textAlign:"center"


            },
            {
                value:'የግብር ባለስልጣን ስም',
                verticalAlign:"top",
                textAlign:"center"


            },


        ]
        const sectionFooterLast2 = [

            {
                value:'ስም_________________ፊርማ______________ቀን_______________',
                verticalAlign:"center"



            },
            {
                value:''
            },
            {
                value: 'ፊርማ________ቀን__________'
            }



        ]

        // var company = [{
        //     value:localStorage.getItem('companyName'),
        //     fontSize: 20,
        //     textAlign: "center",
        //     background:"#098EF6",
        //     color:"#ffffff"
        // },{
        //     value:'',
        //     verticalAlign:"bottom",
        //     fontSize: 15,
        //     textAlign: "right",
        //     background:"#098EF6",
        //     color:"#ffffff",
        //     bold:true
        // }];
        //
        // var sheetTitle = [{
        //     value:`Bank Transfer List   - ${moment(payrollDate).format("MMMM YYYY")} Payroll`,
        //     verticalAlign:"top",
        //     fontSize: 20,
        //     textAlign: "center",
        //     background:"#098EF6",
        //     color:"#ffffff"
        // },
        //     {
        //         value:'Payday.truwrk.com',
        //         verticalAlign:"bottom",
        //         fontSize: 10,
        //         textAlign: "right",
        //         background:"#098EF6",
        //         color:"#ffffff",
        //         bold:true
        //     }];
        //
        const rows = sheet.rows;
        //
        // let altIdx = 0;
        rows.forEach((row) => {
            if(row.type === 'header')
            {
                row.height = 50
                row.cells.forEach((cell) => {
                    cell.borderLeft={size:1}
                    cell.borderRight={size:1}
                    cell.borderBottom={size:1}
                    cell.borderTop={size:1}
                    cell.fontSize = 12
                    cell.background="#F5F5F5"
                    cell.color = "#000"
                    cell.wrap = true
                    cell.bold = true


                });

            }
            if(row.type === 'footer')
            {
                row.height = 30
                row.cells.forEach((cell) => {
                    cell.borderLeft={size:1}
                    cell.borderRight={size:1}
                    cell.borderBottom={size:1}
                    cell.borderTop={size:1}
                    cell.fontSize = 12
                    cell.background="#F5F5F5"
                    cell.color = "#000"
                    cell.bold = true


                });

            }

            if(row.type === 'group-header')
            {
                row.height = 25
                row.cells.forEach((cell) => {
                    cell.borderLeft={size:1}
                    cell.borderRight={size:1}
                    cell.borderBottom={size:1}
                    cell.borderTop={size:1}
                    cell.fontSize = 12
                    cell.background="#BAD8FC"
                    cell.color = "#000"
                    cell.wrap = true
                    cell.bold = true


                });

            }

            if(row.type === 'group-footer')
            {
                row.height = 25
                row.cells.forEach((cell) => {
                    cell.borderLeft={size:1}
                    cell.borderRight={size:1}
                    cell.borderBottom={size:1}
                    cell.borderTop={size:1}
                    cell.fontSize = 12
                    cell.background="#E5E7E7"
                    cell.color = "#000"
                    cell.bold = false


                });

            }


            if (row.type === 'data') {
                // if (altIdx % 2 !== 0) {
                //     row.cells.forEach((cell) => {
                //         cell.background = '#aabbcc';
                //     });
                // }
                // altIdx++;
                row.height = 35
                    row.cells.forEach((cell) => {
                        cell.borderLeft={size:1}
                        cell.borderRight={size:1}
                        cell.borderBottom={size:1}
                        cell.borderTop={size:1}
                        cell.fontSize = 12
                        cell.wrap = true

                    });
            }
        });
        //
        sheet.rows.splice(0, 0, { cells: sectionTwoTitle, height: 30});
        sheet.rows.splice(0, 0, { cells: sectionOne4, height: 30});
        sheet.rows.splice(0, 0, { cells: sectionOne3, height: 30});
        sheet.rows.splice(0, 0, { cells: sectionOne2, height: 30});
        sheet.rows.splice(0, 0, { cells: sectionOne, height: 30});
        sheet.rows.splice(0, 0, { cells: sectionOneTitle, height: 30});
        sheet.rows.splice(0, 0, { cells: headerRow, height: 100});

        sheet.rows.push({ cells: sectionFooterTitle, height: 30})
        sheet.rows.push({ cells: sectionFooter1, height: 50})
        sheet.rows.push({ cells: sectionFooter2, height: 50})
        sheet.rows.push({ cells: sectionFooter3, height: 50})
        sheet.rows.push({ cells: sectionFooter4, height: 30})

        sheet.rows.push({ cells: sectionFooterLastTitle, height: 30})
        sheet.rows.push({ cells: sectionFooterLast1, height: 30})
        sheet.rows.push({ cells: sectionFooterLast2, height: 50})

        sheet.rows.forEach(row=>row.cells.forEach(cell=>{
            if(!(cell.borderLeft&&cell.borderRight&&cell.borderTop&&cell.borderBottom)) {
                {
                    cell.borderLeft = {size: 1}
                    cell.borderRight = {size: 1}
                    cell.borderBottom = {size: 1}
                    cell.borderTop = {size: 1}
                }
            }
        }))






        ref.current.save(options);
    }
    // const defaultHeaderOptions = {wrap:true,fontSize:18, background:"#09a3f6",  borderLeft:{size:1}, borderRight:{size:1}, borderBottom:{size:1},borderTop:{size:1}}

    //const defaultFooterOption= {wrap:true,fontSize:18, background:"#f69709",  borderLeft:{size:1}, borderRight:{size:1}, borderBottom:{size:1},borderTop:{size:1}}
    const CustomGroupFooter = ({column,aggregates}) => {
        return aggregates[column.field]?aggregates[column.field].sum:0
    };

    return (
        <div>

            <Button variant="outlined"  color="primary"  startIcon={<ExcelIcon  style={{ color: green[500] }}/>} onClick={loadLogosAndExportToExcel}>Export to Excel</Button>

            <ExcelExport
                group={group}
                data={group?result.data:data}
                ref={ref}
                fileName={fileName}
            >
                {
                    columns.map((c,index)=> c.show&& <ExcelExportColumn
                        width={c.width} field={c.field} title={c.title}
                        cellOptions={c.type==="Number"&&{format: `_(* #,##${decimalFormat[decimalPlace]}_);_(* (#,##${decimalFormat[decimalPlace]});_(* "-"??_);_(@_)`}} footer={c.type==="Number"?getSum:index===columns.length-2?val=>'Total':null}
                        groupFooter={c.type==="Number"?CustomGroupFooter:null}
                        groupFooterCellOptions={c.type==="Number"?{format: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'}:null}
                        footerCellOptions={c.type==="Number"&&{format: `_(* #,##${decimalFormat[decimalPlace]}_);_(* (#,##${decimalFormat[decimalPlace]});_(* "-"??_);_(@_)`}} />)
                }

                {/*<ExcelExportColumn width={50} field="orgID" title="Work Id" />*/}
                {/*<ExcelExportColumn width={150} field="fullName" title="Employee Name"  />*/}
                {/*<ExcelExportColumn width={100} field="bank" title="Bank" />*/}
                {/*<ExcelExportColumn width={100} field="bankBranch" title="Bank Branch" />*/}
                {/*<ExcelExportColumn width={150} field="bankAccountNumber" title="Account" footer={val=>'Total'}  />*/}
                {/*<ExcelExportColumn width={150} field="cash" title="Net Transfer Amount"  cellOptions={{format: `_(* #,##${decimalFormat[decimalPlace]}_);_(* (#,##${decimalFormat[decimalPlace]});_(* "-"??_);_(@_)`}} footer={getSum} footerCellOptions={{format: `_(* #,##${decimalFormat[decimalPlace]}_);_(* (#,##${decimalFormat[decimalPlace]});_(* "-"??_);_(@_)`}}/>*/}

            </ExcelExport>

        </div>
    );
};

export default IncomeTaxExcelExport;
